import { z } from 'zod/v4'

export const DataSourceStatus = {
	Uploaded: 'uploaded',
	Processing: 'processing',
	Ready: 'ready',
	Error: 'error',
	Created: 'created',
	Failed: 'failed',
} as const

export const DataSourceType = {
	CSV: 'csv',
} as const

export const DataSourceStatusValidator = z.enum([
	DataSourceStatus.Uploaded,
	DataSourceStatus.Processing,
	DataSourceStatus.Ready,
	DataSourceStatus.Error,
	DataSourceStatus.Created,
	DataSourceStatus.Failed,
])

export const DataSourceTypeValidator = z.enum([DataSourceType.CSV])

export const DataSourceSummaryValidator = z.object({
	affectedCells: z.number(),
	min: z.number(),
	max: z.number(),
	sum: z.number(),
})

export const DataSourceValidator = z.object({
	id: z.string(),
	name: z.string(),
	type: DataSourceTypeValidator,
	status: DataSourceStatusValidator,
	total_cells: z.number().nullable().optional(),
	created_at: z.string(),
	updated_at: z.string(),
	completed_at: z.string().nullable().optional(),
	last_updated: z.string().nullable().optional(),
	summaries: z.record(z.string(), DataSourceSummaryValidator).optional(),
	file_path: z.string(),
})

export const BaseDataSourceValidator = DataSourceValidator.omit({
	id: true,
	status: true,
	total_cells: true,
	created_at: true,
	updated_at: true,
	completed_at: true,
	last_updated: true,
	file_path: true,
})

export type DataSource = z.infer<typeof DataSourceValidator>
export type BaseDataSource = z.infer<typeof BaseDataSourceValidator>
